import { assigneeAdapter } from "../../../types";
import {
  AssigneePaginatedResponse,
  PaginationResponse,
} from "../../../types/responses";

export const getAssigneeDetailsFromResponse = (
  response: AssigneePaginatedResponse | undefined,
): { list: assigneeAdapter[]; pagination: PaginationResponse } => {
  if (!response?.list)
    return {
      list: [],
      pagination: {
        page: 0,
        count: 0,
        itemPerPage: 5,
        totalCount: 0,
      },
    };

  const list = response.list.map((p) => {
    return {
      id: p.id,
      name: p.name,
      department: p.department,
      position: p.position,
      contactNo: p.contactNo,
      email: p.email,
      userId: p.userId,
      departmentId: p.departmentId,
      created: p.created,
      createdBy: p.createdBy,
      modifed: p.modified,
      modifiedBy: p.modifiedBy,
    };
  });

  return {
    list,
    pagination: response.pagination,
  };
};
